<template>
  <div class="filter-item">
    <component
      :is="itemComponent"
      ref="filterItem"
      :data="newData"
      :value="value"
      :placeholder="placeholder"
      @change="handleChange"
    />
  </div>
</template>

<script>
import InputFilter from './Input'
import CheckboxFilter from './Checkbox'
import InfotypeCheckboxFilter from './InfotypeCheckbox'
import SelectTreeFilter from './SelectTree'
import AreaFilter from './Area'
import CascaderFilter from './CascaderGroup'
import DateFilter from './Date'
import NumberFilter from './Number'

export default {
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default: () => ({})
    },
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // itemComponent: ''
    }
  },
  computed: {
    value () {
      const { filter } = this
      const { fieldkey } = this.data
      // return filter[fieldkey] && filter[fieldkey].fieldvalue
      let { fieldtype, fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign = {} } = fieldconfig
      let value = filter[fieldkey] && filter[fieldkey].fieldvalue

      switch (fieldtype) {
        case 'text':
        case 'ip':
          value = value || ''
          break
        case 'number':
          value = value || {} // min max
          break
        case 'phone':
        case 'email':
          value = value || []
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_followup':
        case 'checkbox':
          value = value || []
          break
        case 'radioinfo_type':
          value = value || []
          if (this.data.fieldconfig && this.data.fieldconfig.info_sign) {
            this.$set(this.data.fieldconfig.info_sign, 'fieldvalue', infoSign.fieldvalue || [])
          }
          break
        case 'selectfollowuser':
        case 'selectinputuser':
          value = value || {}
          break
        case 'selectrolegroup':
        case 'selectuser':
          value = value || [] // roleid, groupid, userid
          break
        case 'from_info':
        case 'select_reception': // 接待方式
          value = value || []
          break
        case 'select_tree':
          value = value || {}
          break
        case 'timezones': // 时间区间
        case 'datetime':
        case 'followup_remind_time':
          value = value || { starttime: '', endtime: '' }
          break
        case 'area':
          value = value || {}
          break
      }
      return value
    },
    itemComponent () {
      let component = ''
      const { fieldtype } = this.data || {}

      switch (fieldtype) {
        case 'text':
        case 'ip':
          component = InputFilter
          break
        case 'number':
          component = NumberFilter
          break
        case 'phone':
        case 'email':
          component = InputFilter
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_followup':
        case 'checkbox':
        case 'radioinfo_level':
          component = CheckboxFilter
          break
        case 'radioinfo_type':
          component = InfotypeCheckboxFilter
          break
        case 'selectrolegroup':
        case 'selectfollowuser':
        case 'selectinputuser':
        case 'selectuser':
        case 'from_info':
        case 'select_reception': // 接待方式
          component = CascaderFilter
          break
        case 'select_tree':
          component = SelectTreeFilter
          break
        case 'timezones': // 时间区间
        case 'datetime':
        case 'followup_remind_time':
          component = DateFilter
          break
        case 'area':
          component = AreaFilter
          break
      }
      return component
    },
    newData () {
      const { data = {} } = this
      const { fieldtype, fieldconfig = {} } = data
      const starArr = this.$t('message["1380"]').split(',')

      if (fieldtype === 'radioinfo_level') {
        const maps = fieldconfig.type === 1 ? ['A', 'B', 'C', 'D', 'E', 'F', 'G'] : starArr
        const { options = [] } = data
        options.map((item, index) => {
          item.name = maps[index]
        })
      }
      data.rules = {}
      data.messages = {}
      return data
    },
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      let string = placeholder || this.$t('message["855"]') + spaceStr + fieldname

      return string
    }
  },
  methods: {
    validate (cb) {
      this.$refs.filterItem && this.$refs.filterItem.validate && this.$refs.filterItem.validate(cb)
    },
    handleChange (val) {
      this.data.fieldvalue = val
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-item::v-deep {
  margin-bottom: 8px;
  background: #fff;
  .cube-input::placeholder {
    color: #d6d6d6;
  }
  .cube-input:after {
    width: 0;
    border: none;
  }
  .filter-tit {
    padding: 12px 12px 6px 12px;
    font-size: 14px;
    line-height: 24px;
    color: #999;
  }
  .item-tag {
    display: inline-block;
    background: rgba(0, 0, 0, 0.25);
    color: #fff;
    padding: 0 4px;
    height: 16px;
    line-height: 16px;
    border-radius: 4px;
    margin-right: 6px;
    font-size: 12px;
  }
}
</style>
